import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=d3f9f1d2&"
import script from "./setup.vue?vue&type=script&setup=true&lang=js&"
export * from "./setup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports